import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { EmailTemplateApi } from 'api';
import type { EmailTemplate } from 'api/methods/EmailTemplateApi';

/**
 * [EmailTemplate] Query Key 생성
 * --
 */
export const emailTemplateQueryKeys = createQueryKeys('emailtemplate', {
  getEmailTemplate: (
    idx: number,
    params?: { [key: string]: string | number }
  ) => [idx, params],
  getEmailTemplates: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [EmailTemplate] 이메일 탬플릿 상세 조회
 * --
 */
export const useGetEmailTemplate = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: emailTemplateQueryKeys.getEmailTemplate(idx, params).queryKey,
    queryFn: () => EmailTemplateApi.getEmailTemplate(idx, params),
  });

  return data;
};

/**
 * [EmailTemplate] 이메일 탬플릿 전체 조회
 * --
 */
export const useGetEmailTemplates = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: emailTemplateQueryKeys.getEmailTemplates(params).queryKey,
    queryFn: () => EmailTemplateApi.getEmailTemplates(params),
    ...options,
  });

  return data;
};

/**
 * [EmailTemplate] 이메일 탬플릿 생성
 * --
 */
export const useCreateEmailTemplate = (body: EmailTemplate) => {
  const { mutateAsync: createEmailTemplate, ...result } = useMutation({
    mutationFn: (variables: EmailTemplate) =>
      EmailTemplateApi.createEmailTemplate(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createEmailTemplate, ...result };
};

/**
 * [EmailTemplate] 이메일 탬플릿 수정
 * --
 */
export const useUpdateEmailTemplate = (body: EmailTemplate) => {
  const { mutateAsync: updateEmailTemplate, ...result } = useMutation({
    mutationFn: (variables: EmailTemplate) =>
      EmailTemplateApi.updateEmailTemplate(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateEmailTemplate, ...result };
};

/**
 * [EmailTemplate] 이메일 탬플릿 삭제
 * --
 */
export const useDeleteEmailTemplate = (idx: number) => {
  const { mutateAsync: deleteEmailTemplate, ...result } = useMutation({
    mutationFn: (variables: number) =>
      EmailTemplateApi.deleteEmailTemplate(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteEmailTemplate, ...result };
};
